import { Navigate } from "react-router-dom";
import { jt, t } from "ttag";

import { ScreenLayout } from "@/app/components/layouts";
import { ROUTES } from "@/app/router";
import { usePortalUserStore } from "@/app/stores";
import { ScheduleContextProvider } from "@/features/consultations/contexts";
import { APPOINTMENT_TYPE } from "@/features/consultations/models";
import {
  ScheduleAvailableDaysCard,
  ScheduleAvailableTimeSlotCard,
} from "@/features/consultations/sections";
import { CATEGORY_SLUG } from "@/shared/domains";
import { useBoolean } from "@/shared/hooks";
import { AVAILABLE_LANGUAGE } from "@/shared/models";
import { Alert, ShieldCheckIcon } from "@/shared/ui";
import { useIntakeFormContext } from "../context";
import { LanguagePreference, Submit } from "../sections";

export const VideoConsultation = () => {
  const preferredLanguage = usePortalUserStore(
    (state) => state.portalUser?.preferredLanguage ?? AVAILABLE_LANGUAGE.EN,
  );
  const { patient, completed, subscription } = useIntakeFormContext();
  const location = patient.location;

  const { value: showLanguageSelector, setTrue: openLanguageSelector } =
    useBoolean(false);

  if (completed) {
    return <Navigate to={ROUTES.BASE} />;
  }

  const selectorOpener = (
    <button
      key="language-selector-opener"
      type="button"
      onClick={openLanguageSelector}
      className="underline"
    >
      {t`here`}
    </button>
  );

  const appointmentType =
    subscription.currentProduct.category.slug === CATEGORY_SLUG.TESTOSTERONE
      ? APPOINTMENT_TYPE.TESTOSTERONE
      : APPOINTMENT_TYPE.MEDICATION_REQUEST_INITIAL;

  return (
    <ScreenLayout
      title={`${t`Let's meet`}!`}
      description={t`Choose the perfect time and date`}
    >
      {!showLanguageSelector && (
        <Alert icon={ShieldCheckIcon}>
          {jt`These are the available consultations based on your language preference. If you'd like, you can change your preferred language for the consultation by clicking ${selectorOpener}.`}
        </Alert>
      )}

      <ScheduleContextProvider
        defaultLanguage={preferredLanguage}
        appointmentType={appointmentType}
        state={location?.state}
        subscriptionId={subscription.id}
      >
        {showLanguageSelector && <LanguagePreference />}

        <div className="flex flex-col gap-8 lg:flex-row">
          <ScheduleAvailableDaysCard
            title={`1. ${t`Choose an available day`}`}
            className="lg:w-1/2"
            ghost
          />

          <ScheduleAvailableTimeSlotCard
            titleStep={2}
            variant="section"
            className="lg:w-1/2"
          />
        </div>

        <Submit />
      </ScheduleContextProvider>
    </ScreenLayout>
  );
};
